import { GenericAbortSignal } from 'axios';
import { ICatalogueProducts, ISuggestionSection } from 'core/model/interfaces/catalogues.interface';
import { IPaginatedProducts, IPaginatedProductsParams } from 'core/model/interfaces/product.interface';
import { catalogsData } from './catalogs.data';
import { IGetListProductsParams, IGetProductDetailParams, IGetSuggestionsParams } from './catalogs.dto';
import {
  catalogDetailResponseToProduct,
  catalogProductosParamsToBody,
  getSuggestionSections,
  listProductsToPaginatedProducts,
  navigationCatalogToCatalogueProducts,
} from './catalogs.mappers';

export const catalogsService = {
  getListProducts: async (
    params: IGetListProductsParams,
    customerId: number,
    signal?: GenericAbortSignal,
  ): Promise<IPaginatedProducts> => {
    const listProducts = await catalogsData.getListProducts(params, customerId, signal);
    return listProductsToPaginatedProducts(listProducts);
  },

  getProductDetail: async (params: IGetProductDetailParams, customerId: number) => {
    const product = await catalogsData.getProductDetail(params, customerId);
    return catalogDetailResponseToProduct(product);
  },

  getCatalogProducts: async (params: IPaginatedProductsParams): Promise<Array<ICatalogueProducts>> => {
    const { customerId, parentId } = params;
    const body = catalogProductosParamsToBody(params);
    const { navigationItems, navigationSubItems } = await catalogsData.getCatalogProducts(body, customerId);

    const treeItemType = parentId ? 'subcategory' : 'category';
    if (treeItemType === 'category')
      return navigationItems.map(item => navigationCatalogToCatalogueProducts(item, treeItemType));
    return navigationSubItems.map(item => navigationCatalogToCatalogueProducts(item, treeItemType));
  },

  getSuggestions: async (params: IGetSuggestionsParams, customerId: number): Promise<ISuggestionSection> => {
    const response = await catalogsData.getSuggestions(params, customerId);
    const suggestionSections = getSuggestionSections(response, params.suggestionTypeId);
    return suggestionSections;
  },
};
